var _style, _defs, _mask, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningBankDataRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37 24",
    style: {
      enableBackground: "new 0 0 37 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_3560_28513_00000150802809521677256180000011019057136736468358_);}\r\n\t.st2{fill:#15B79E;}\r\n\t.st3{fill:#F59E0B;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3.8,
    y: 2.1,
    width: 16.9,
    height: 17.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3.8,
    y: 2.1,
    width: 16.9,
    height: 17.9,
    id: "mask0_3560_28513_00000150802809521677256180000011019057136736468358_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.7,17V9h1v8H6.7z M11.7,17V9h1v8H11.7z M3.8,20v-1h16.9v1H3.8z M16.7,17V9h1v8H16.7z M3.8,7V6.2l8.5-4l8.5,4 V7H3.8z M6.4,6h11.6l-5.8-2.8L6.4,6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Exclamation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st3",
    d: "M26.2,15.5c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.3-0.1-0.4 c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.3C26,15.5,26.1,15.5,26.2,15.5z  M25.9,12.9h0.8V8.1h-0.8V12.9z M26.2,19.2c-1,0-1.9-0.2-2.8-0.6c-0.9-0.4-1.6-0.9-2.3-1.5c-0.6-0.6-1.2-1.4-1.5-2.3 c-0.4-0.9-0.6-1.8-0.6-2.8s0.2-1.9,0.6-2.8c0.4-0.9,0.9-1.6,1.5-2.3c0.6-0.6,1.4-1.2,2.3-1.5c0.9-0.4,1.8-0.6,2.8-0.6 S28.2,5,29,5.4c0.9,0.4,1.6,0.9,2.3,1.5c0.6,0.6,1.2,1.4,1.5,2.3c0.4,0.9,0.6,1.8,0.6,2.8s-0.2,1.9-0.6,2.8 c-0.4,0.9-0.9,1.6-1.5,2.3c-0.6,0.6-1.4,1.2-2.3,1.5C28.2,19,27.2,19.2,26.2,19.2z M26.2,18.4c1.8,0,3.3-0.6,4.5-1.9 c1.2-1.2,1.9-2.7,1.9-4.5c0-1.8-0.6-3.3-1.9-4.5c-1.2-1.2-2.7-1.9-4.5-1.9c-1.8,0-3.3,0.6-4.5,1.9c-1.2,1.2-1.9,2.7-1.9,4.5 c0,1.8,0.6,3.3,1.9,4.5C23,17.8,24.5,18.4,26.2,18.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBankDataRegistryIcon);
export default __webpack_public_path__ + "static/media/warning-bank-data-registry-icon.0025d96d0ccd7ccee7393c7215eb6802.svg";
export { ForwardRef as ReactComponent };